<template>
  <div>
    <sweet-modal blocking :title="$t('modal_addProgressNote')" width="900px" ref="createProjectTaskProgress" class="modal" v-on:close="close">
      <!--{{selectedRow}}<br>-->
      <!--{{formCreateProjectTaskProgress.progress}}-->
      <el-form label-position="left" :model="formCreateProjectTaskProgress" status-icon :rules="rules" ref="formCreateProjectTaskProgress" label-width="100px" class="demo-ruleForm">

        <template v-if="parentBill">
          <el-form-item label-width="0">
            <el-switch v-model="formCreateProjectTaskProgress.isBillable" :active-text="$t('modal_billing')"></el-switch>
          </el-form-item>

          <el-row v-if="formCreateProjectTaskProgress.isBillable" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="assignmentsId" label-width="0">
                <el-select v-model="formCreateProjectTaskProgress.assignmentsId" :placeholder="$t('modal_assignments')" clearable style="width: 100%;">
                  <el-option v-for="item in formCreateProjectTaskProgress.assignments"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="selectAssignments(item)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="activitiesId" label-width="0">
                <el-select v-model="formCreateProjectTaskProgress.activitiesId" :placeholder="$t('modal_activities')" clearable style="width: 100%;">
                  <el-option v-for="item in formCreateProjectTaskProgress.activities"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="formCreateProjectTaskProgress.isBillable">
            <el-col :span="24">
              <el-form-item label-width="0" prop="title">
                <el-input v-model="formCreateProjectTaskProgress.title" :label="$t('modal_shortNote')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-form-item class="text-block" label-position="top" label-width="0">
          <vue2-custom-editor
              ref="editor"
              v-model="formCreateProjectTaskProgress.text">
          </vue2-custom-editor>
          <!--<el-input type="textarea" placeholder="Text" v-model="formCreateProjectTaskProgress.text"></el-input>-->
        </el-form-item>
        <div class="reminder-block">
          <el-form-item :label="$t('modal_timeSpent')">
            <el-time-picker
              v-model="formCreateProjectTaskProgress.timeSpent"
              value-format='HHmm'
              format='HH:mm'
              :picker-options="{
                align: 'center'
              }"
              placeholder="Arbitrary time">
            </el-time-picker>
          </el-form-item>
          <div class="reminder-block_date">
            <el-form-item prop="isReminderActive" :label="$t('modal_setReminder')" label-width="120px">
              <el-checkbox @change="isReminderActiveChange(formCreateProjectTaskProgress.isReminderActive)" name="type" v-model="formCreateProjectTaskProgress.isReminderActive"></el-checkbox>
            </el-form-item>
            <el-form-item prop="reminderDate" label-width="20px">
              <el-date-picker
                      format="d MMM yy h : mm A"
                      :disabled="!formCreateProjectTaskProgress.isReminderActive"
                      v-model="formCreateProjectTaskProgress.reminderDate"
                      type="datetime"
                      :placeholder="$t('modal_pickADate')"
                      value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
        </div>
        <!--<el-button slot="trigger" size="small" type="primary">Add Media</el-button>-->
        <!-- <div class="upload-media">
          <el-upload
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :auto-upload="false"
                  :file-list="fileList">
            <el-button slot="trigger" size="small" type="primary">Add Media</el-button>
          </el-upload>
        </div> -->
        <el-form-item :label="$t('modal_progress')" prop="Progress" >
          <el-slider
                  v-model="formCreateProjectTaskProgress.progress"
                  :max="100"
                  :min="0"
                  :step="5"
                  show-stops>
          </el-slider>
        </el-form-item>
        <!-- <el-form-item label="Hours spent">
          <el-input placeholder="Hours spent" v-model="formCreateProjectTaskProgress.hoursSpent"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="Minutes spent">
          <el-input placeholder="Minutes spent" v-model="formCreateProjectTaskProgress.minutesSpent"></el-input>
        </el-form-item> -->
        <div class="flex-twocolumn">
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyProjectTeam" :active-text="$t('modal_notifyManagement')"></el-switch>
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyTaskTeam" :active-text="$t('modal_notifyTaskTeam')"></el-switch>
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch :disabled="allowNotification || !projectPermission.addProgressNotifyClients" v-model="formCreateProjectTaskProgress.notifyClients" :active-text="$t('modal_notifyClients')"></el-switch>
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch :disabled="allowNotification || !projectPermission.addProgressNotifyVendors" v-model="formCreateProjectTaskProgress.notifyVendors" :active-text="$t('modal_notifyVendors')"></el-switch>
            </el-form-item>
        </div>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('createProjectTaskProgress')">{{$t('general_cancel')}}</el-button>
          <el-button @click="createProjectTaskProgressSubmit('formCreateProjectTaskProgress')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
      <!--{{allowNotification}}-->
    </sweet-modal>
    <!--<sweet-modal  ref="formReminder" v-on:close="closeReminder">-->
      <!--<el-form :model="formReminder">-->
        <!--<el-form-item>-->
          <!--<vue-editor v-model="formReminder.description"></vue-editor>-->
        <!--</el-form-item>-->
        <!--<el-form-item>-->
          <!--<el-button @click="setReminderSubmit" class="modal__btn" type="primary" plain size="medium">Set reminder</el-button>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
    <!--</sweet-modal>-->
  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

import axios from 'axios';
import Vue2CustomEditor from "../vue-2-custom-editor";

export default {
  components: {
    Vue2CustomEditor,
    SweetModal
  },
  props: [
    'selectedRow',
    'activeProjectId',
    'allowNotification',
    'assignmentList',
    'projectPermission',
    'parentBill'
  ],
  mounted() {
    this.createProjectTaskProgressOpen();
    this.formCreateProjectTaskProgress.progress = this.selectedRow.progress
  },
  data() {
    var checkDate = (rule, value, callback) => {
      if (!value && this.formCreateProjectTaskProgress.isReminderActive) {
        return callback(new Error('Please input the date'));
      }else callback();
    };
    return {
      projectTaskId: 0,
      formCreateProjectTaskProgress: {
        activitiesId: null,
        activities: [],
        assignmentsId: null,
        assignments: [],

        progress: 0,
        isBillable: true,
        title: '',
        text: '',
        timeSpent: '0000',
        hoursSpent: 0,
        minutesSpent: 0,
        notifyProjectTeam: false,
        notifyTaskTeam: true,
        notifyClients: false,
        notifyVendors: false,
        isReminderActive: false,
        reminderDate: ''
      },
      // formReminder:{
      //   reminder:'',
      //   description:''
      // },
      fileList:[],
      rules: {
        activitiesId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        assignmentsId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        reminderDate: [{ validator: checkDate, trigger: 'blur' }],
      }
    }
  },
  methods: {
    selectAssignments(item) {
      this.formCreateProjectTaskProgress.activitiesId = null
      this.formCreateProjectTaskProgress.activities = item.activities
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    isReminderActiveChange(value){
      if(!value){
        this.$refs['formCreateProjectTaskProgress'].resetFields();
      }
    },
    // formated(){
    //   return this.selectedRow.progress.toString() + '%'
    // },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type,
      });
    },

    createProjectTaskProgressOpen() {
    },

    createProjectTaskProgressSubmit(form) {
      if(!this.formCreateProjectTaskProgress.progress){
        return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeNull'), "info")
      }
      if(this.formCreateProjectTaskProgress.progress < this.selectedRow.progress){
        return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeLess'), "info")
      }
      console.log('---', 'submit create');
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          if (this.formCreateProjectTaskProgress.timeSpent) {
            let time, hours, minutes;
            time = this.formCreateProjectTaskProgress.timeSpent;
            hours = time.slice(0, 2);
            minutes = time.slice(2, 4);
            this.formCreateProjectTaskProgress.hoursSpent = hours
            this.formCreateProjectTaskProgress.minutesSpent = minutes
          }
          if(this.formCreateProjectTaskProgress.reminderDate === ''){
            this.formCreateProjectTaskProgress.reminderDate = null
          }
          if (!this.formCreateProjectTaskProgress.isBillable) {
            this.formCreateProjectTaskProgress.title = ''
            this.formCreateProjectTaskProgress.activitiesId = null
            this.formCreateProjectTaskProgress.assignmentsId = null
          }
          axios
          .post(`/api/v1/projectTaskProgresses/create?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.projectTaskId}`, {
            text: this.formCreateProjectTaskProgress.text,
            progress: this.formCreateProjectTaskProgress.progress,
            notifyProjectTeam: this.formCreateProjectTaskProgress.notifyProjectTeam,
            notifyTaskTeam: this.formCreateProjectTaskProgress.notifyTaskTeam,
            notifyClients: this.formCreateProjectTaskProgress.notifyClients,
            notifyVendors: this.formCreateProjectTaskProgress.notifyVendors,
            hoursSpent: this.formCreateProjectTaskProgress.hoursSpent,
            minutesSpent: this.formCreateProjectTaskProgress.minutesSpent,
            isReminderActive: this.formCreateProjectTaskProgress.isReminderActive,
            reminderDate: this.formCreateProjectTaskProgress.reminderDate / 1000,
            title: this.formCreateProjectTaskProgress.title,
            isBillable: this.parentBill ? this.formCreateProjectTaskProgress.isBillable : false,
            projectTaskProgressActivityId: this.formCreateProjectTaskProgress.activitiesId,
            projectTaskProgressAssignmentId: this.formCreateProjectTaskProgress.assignmentsId,
            timer: false,
          })
          .then(response => {
            if(response.data.success){
              if (this.$refs.editor.uploadedImagesArray.length) {
                this.$store.dispatch('approveUploadedImages', {
                  fileUrlArr: this.$refs.editor.uploadedImagesArray,
                  entityId: response.data.projectTaskProgressId,
                  entityTypeId: 30 // project progress
                })
              }
              // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
              let data = {'taskId': this.projectTaskId, 'projectId': this.activeProjectId};
              this.notification(this.$t('general_success'), this.$t('modal_addProgressNote_addProgressNote'), "success");
              this.$store.dispatch('getProgressesList', data)
              loader.hide()
              this.$emit('submit', this.activeProjectId)
              this.$refs.createProjectTaskProgress.close();
            }
            console.log(response)
          })
          .catch(error => {
            loader.hide()
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close(){
      // this.formCreateProjectTaskProgress.progress = 0
      this.formCreateProjectTaskProgress.text = ''
      this.formCreateProjectTaskProgress.hoursSpent = 0
      this.formCreateProjectTaskProgress.minutesSpent = 0
      this.formCreateProjectTaskProgress.notifyProjectTeam = false
      this.formCreateProjectTaskProgress.notifyTaskTeam = true
      this.formCreateProjectTaskProgress.notifyClients = false
      this.formCreateProjectTaskProgress.notifyVendors = false
      this.formCreateProjectTaskProgress.reminderDate = ''
      this.formCreateProjectTaskProgress.isReminderActive = false
      this.formCreateProjectTaskProgress.timeSpent = '0000'
      this.formCreateProjectTaskProgress.title = ''
      this.formCreateProjectTaskProgress.isBillable = true
      this.formCreateProjectTaskProgress.activitiesId = null
      this.formCreateProjectTaskProgress.assignmentsId = null
    },
    // closeReminder(){
    //   this.formReminder.description = ''
    //   this.formReminder.reminder = ''
    // },
    // setReminderSubmit(){
    //   console.log('SET REMINDER')
    //     axios
    //             .post(`/api/v1/reminders/create`, {
    //               date: this.formReminder.reminder,
    //               text: this.formReminder.description,
    //               entityType: localStorage.getItem('selectedProjectId'),
    //               entityId: this.selectedRow.id
    //             })
    //             .then(response => {
    //               if(response.data.success){
    //                 this.$refs.formReminder.close();
    //                 this.notification("Success", "Reminder successfully sent", "success");
    //                 console.log("reminder response", response.data)
    //               }
    //             })
    //             .catch(error => {
    //               loader.hide()
    //               this.$refs.formReminder.close();
    //               this.notification("Notification", error.response.data.message, "info")
    //             });
    // },
  },
  watch:{
    selectedRow(sed){
      console.log(sed)
      this.formCreateProjectTaskProgress.progress = sed.progress
    },
    assignmentList(val) {
      this.formCreateProjectTaskProgress.assignments = val
    },
  }
};

</script>

<style lang="less" scoped>
  .text-block{
    display:flex;
    flex-direction:column;
  }
  .reminder-block{
    justify-content: space-between;
    display:flex;
    &_date{
      display:flex;
    }
  }
  .reminder-datepicker{
    margin-left:0;
  }
  .flex-twocolumn{
    display:flex;
    &_second-column{
      margin-left:20px;
    }
  }
  .flex-end{
    display:flex;
    justify-content:flex-end;
  }
  .sweet-modal-overlay{
    z-index:1000;
  }
  /*.remider{*/
    /*display:flex;*/
    /*justify-content:flex-end;*/
    /*margin-bottom:10px;*/
  /*}*/
  .upload-media{
    display:flex;
    justify-content:flex-end;
  }
</style>

<style lang="less">
  .flex-twocolumn{
    display:flex;
    .el-form-item__content{
      margin:0 12px;
      font-size:13px;
    }
  }
  .reminder-block{
    .el-date-editor.el-input{
      width: 160px;
    }
  }
</style>
